module.exports = __webpack_public_path__ + "assets/img/de.246a5fcb.svg";